import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loginActions } from '../../../store/user-login.reducer';
import ButtonIcon from '../../button';
import backgroundImg from "../../../../img/full-page-bg.png"
import clientLogo from "../../../../img/ATEM-LOGO-White@2x.png"
class LogOut extends Component {
    login = async (e) => {
        e.preventDefault();
        window.location.href = '/userlogin';
    }
    render() {
        return (
            <div>
                <div className="login-container">
                    <div className="login-left-container">
                        <img src={backgroundImg} alt="background" className="blue-img" />
                        <h1 className="login-header">Welcome to</h1>
                        <img src={clientLogo} alt="background" className="client-img" />
                        <span className="login-sub-text">
                            Accenture Technology Expense Management
                        </span>
                    </div>
                    <div className="login-right-container">
                        <h1>Logout</h1>
                        <h4>You have been logged out.</h4>
                        <br/>
                        <ButtonIcon onClick={(e) => this.login(e)} iconLeft="sign-out-alt" iconSize="16px" customClassName="userprofile-logout" labelName="Login page" />
                    </div>

                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        ...bindActionCreators(loginActions, dispatch)
    }
}

function mapStateToProps(state) {
    return {
        ...state,
        ...state.history
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LogOut);
